module.exports = __webpack_public_path__ + "img/icon-const-norm-bg-9.e9f6e5f3.png";